import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = { class: "gdp-growth-chart" }
const _hoisted_3 = { class: "gdp-growth-chart__wrapper" }
const _hoisted_4 = { class: "top-statistic-countries" }
const _hoisted_5 = { class: "top-statistic-countries__index" }
const _hoisted_6 = { class: "top-statistic-countries__index" }
const _hoisted_7 = { class: "top-statistic-countries__index" }
const _hoisted_8 = { class: "top-statistic-countries__index" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TecRussia = _resolveComponent("TecRussia")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_SectionTitle = _resolveComponent("SectionTitle")!
  const _component_EChartsHorizontalBar = _resolveComponent("EChartsHorizontalBar")!
  const _component_TopCountryStatistic = _resolveComponent("TopCountryStatistic")!
  const _component_EconomicsReview = _resolveComponent("EconomicsReview")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TecRussia, {
      countryId: _ctx.countryId,
      unfriendlyCountryInfo: _ctx.getInfoAboutUnfriendlyCountry
    }, null, 8, ["countryId", "unfriendlyCountryInfo"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Loader)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_SectionTitle, { text: "Рост ВВП в сравнении с другими странами (%, г/г)" }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_EChartsHorizontalBar, _mergeProps(_ctx.gdpChartBind, {
                labels: _ctx.gdpCategories,
                dataset: _ctx.gdpDataset,
                height: _ctx.resolveChartHeight(_ctx.gdpCategories.length, true)
              }), null, 16, ["labels", "dataset", "height"])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_TopCountryStatistic, {
                title: "Топ-5 отраслей импорта",
                content: _ctx.getIndustriesOfTopImport
              }, null, 8, ["content"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_TopCountryStatistic, {
                title: "Топ-5 отраслей экспорта",
                content: _ctx.getIndustriesOfTopExport
              }, null, 8, ["content"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_EChartsHorizontalBar, _mergeProps(_ctx.topCountriesChartBind, {
                titleConfig: { text: 'Топ-5 стран импорта' },
                labels: _ctx.importCountryData.labels,
                dataset: _ctx.importCountryData.dataset,
                height: _ctx.resolveChartHeight(_ctx.importCountryData.labels.length)
              }), null, 16, ["labels", "dataset", "height"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_EChartsHorizontalBar, _mergeProps(_ctx.topCountriesChartBind, {
                titleConfig: { text: 'Топ-5 стран экспорта' },
                labels: _ctx.exportCountryData.labels,
                dataset: _ctx.exportCountryData.dataset,
                height: _ctx.resolveChartHeight(_ctx.exportCountryData.labels.length)
              }), null, 16, ["labels", "dataset", "height"])
            ])
          ])
        ], 64)),
    _createVNode(_component_EconomicsReview, { countryId: _ctx.countryId }, null, 8, ["countryId"])
  ], 64))
}